import { Component, OnInit, OnDestroy, DoCheck, Input, ViewChild, ViewContainerRef, ComponentRef, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FlexQuestionsService } from '../../../_services/flex-questions.service';

@Component({
  selector: 'app-question-section',
  templateUrl: './section.pane.component.html'
})
export class SectionPaneComponent implements OnInit, OnDestroy, DoCheck {
  @ViewChild("sectionContainer", { read: ViewContainerRef }) sectionContainer: ViewContainerRef;
  @Output() next: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() prompt:string;
  @Input() slug:string;
  @Input() questionid:number;

  errorFlag: boolean;
  successMessage: string;
  errorMessage: string;
  children:any[];
  _sidebar:any;
  currentSection:string;
  formSection:FormGroup;
  loading:boolean;

  constructor(
    private route: ActivatedRoute,
    private flexapi: FlexQuestionsService
  ){
    this.children = [];
  }

  isValid():boolean {
    for(let i in this.children){
      try {
        if(!this.children[i].instance.isValid()) {
          return false;
        }
      } catch(err) {
        console.log('child error',this.children[i].instance.prompt,err);
        return false;
      }
    }
    return true;
  }
  validate():boolean {
    var result:boolean=true;
    for(let i in this.children){
      try {
        if(!this.children[i].instance.validate()) {
          console.log('validation failed',this.children[i].instance.prompt);
          result=false;
        }
      } catch(err) {
        console.log('child error',this.children[i].instance.prompt,err);
        result=false;
      }
    }
    return result;
  }

  getValue():object {
    var result={};
    for(let i in this.children){
      Object.assign(result,this.children[i].instance.getValue());
    }
    return result;
  }

  onSubmit(){
    var val;
    if(this.validate()) {
      this.loading=true;
      val=this.getValue();
      this.flexapi.patchQuestionsData$(val).subscribe(
        (data)=>{
          this.loading=false;
          window.scrollTo(300, 500);
          console.log(this.loading,data);
          this.next.emit(true);
          this._sidebar.complete=true;
        },
        (err)=>{
          window.scrollTo(300, 500);
          this.loading=false;
          console.log(err);
        }
      );
    } else {
      window.scrollTo(300, 500);
    }
  }

  get sidebar():any {
    if('_sidebar' in this) {
      return this._sidebar;
    }
    return undefined;
  }

  set sidebar(sidebar:any){
    this._sidebar=sidebar;
  }

  addChild(factory,itemdata){
    var componentRef:ComponentRef<any>=this.sectionContainer.createComponent(factory);
    this.children.push(componentRef);
    for(let i in itemdata) {
      componentRef.instance[i]=itemdata[i];
    }
    return componentRef.instance;
  }

  ngDoCheck() {
    this.route.params.subscribe((params)=>{
      this.currentSection=params.sectionName;
    });
  }
  ngOnInit() {
  }

  ngAfterViewInit() {
    var sub;
    if(this._sidebar.ready) {
      this._sidebar.complete=this.isValid();
    } else {
      sub=this._sidebar.readyChange.subscribe((isReady)=>{
        sub.unsubscribe();
        this._sidebar.complete=this.isValid();
      });
    }
  }

  ngOnDestroy() {
    var C;
    while(C=this.children.pop()) {
      C.destroy();
    }
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/section.pane.component.ts